/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiShareAImportIcon16Light = forwardRef('ArrowUiShareAImportIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.06 3.4A3 3 0 0 1 6 1h6a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-.5a.5.5 0 0 1 1 0v.5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6a2 2 0 0 0-1.96 1.6.5.5 0 0 1-.98-.2Z" }),
        React.createElement("path", { d: "M.5 3a.5.5 0 0 1 .5.5v.05A3.45 3.45 0 0 0 4.45 7h5.343L7.646 4.854a.5.5 0 1 1 .708-.708l2.292 2.293a1.5 1.5 0 0 1 0 2.122l-2.292 2.293a.5.5 0 0 1-.708-.708L9.793 8H4.45A4.45 4.45 0 0 1 0 3.55V3.5A.5.5 0 0 1 .5 3Z" })));
});
